import React from "react"
import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import { NavigationPath } from "../ProHomeLayout/NavigationPath"

export const ProCalendarLayout = () => {
  return (
    <Layout>
      <NavigationPath className="pl-m pr-m bg-white" subPages={[]} />
      <Outlet />
    </Layout>
  )
}
